/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import RenderDocument from "js_renderer";

export type TElementId = string;
export type TGroupId = number;

export default
class Factory {

    private static registeredElements: any = {};

    public static getNewGUID(): TElementId {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    public static register(aClass: any) {
        Factory.registeredElements[aClass.TypeName] = aClass;
    }

    public static createAPIElement(aRenderDocument: RenderDocument, aTypeName: string) {
        let type: any = Factory.registeredElements[aTypeName];
        if (type !== undefined) {
            return type.create(aRenderDocument);
        } else {
            // fallback when the type is not known
            return Factory.registeredElements["Element"].create(aRenderDocument);
        }
    }
}
